module.exports = __webpack_public_path__ + "static/img/loupe.103edc61.svg";